import api from './api'

const salesforceService = {
  /**
   * Enviar datos del lead a Salesforce
   * @param {Object} leadData - Datos del lead
   * @param {string} leadData.firstName - Nombre del estudiante
   * @param {string} leadData.lastName - Apellidos del estudiante
   * @param {string} leadData.rut - RUT del estudiante
   * @param {string} leadData.email - Email del estudiante
   * @param {string} leadData.phone - Teléfono del estudiante
   * @param {string} leadData.birthDate - Fecha de nacimiento
   * @param {string} leadData.landing - Origen del landing
   * @param {string} leadData.origin - Origen del lead
   * @param {string} leadData.campus - Sede seleccionada
   * @param {string} leadData.program - Programa seleccionado
   * @returns {Promise} Respuesta de la API
   */
  async createLead(leadData) {
    try {
      const response = await api.post('/salesforce/lead', leadData)
      return response.data
    } catch (error) {
      console.error('❌ Error al enviar datos a Salesforce:', error)
      throw error
    }
  }
}

export default salesforceService
